export default {
    signin: 'Login',
    signup: 'Sign Up',
    time_limited: 'Time-Limited',
    time_limited_618: 'Buy 1 Get 1 Free (Time-Limited)',
    lable_recommended: 'Recommended',
    label_enterprise: 'Enterprise',
    menu: {
        item_1: 'AI Translation Model',
        item_2: 'Translation Agent',
        item_3: 'AI Toolkit',
        item_4: 'Price',
        item_5: 'Community',
        item_6: 'A Letter',
    },
    index: {
        banner_1_title: 'Born for Language Lovers and Professionals',
        banner_1_btn: 'Free Trial',
        banner_1_btn_2: 'Join Waitlist',
        banner_2_title: 'LanguageX Won the 2022/2023 WMT International Machine Translation Competition',
        banner_2_btn: 'View More',
        model_1_title: 'AI Translation Platform Built for Professional Language Services',
        model_1_desc: 'Best practices in large AI translation models, project management, and expert collaboration',
        model_1_item_1_title: 'AI Translation Models — Handpicked for You',
        model_1_item_1_desc:
            'The world’s most professional translation models, with precise terminology control, both integrated into human–machine collaboration',
        model_1_item_2_title: 'LLM Translation Agent',
        model_1_item_2_desc:
            'A localization “team” of agents composed of terminology engineers, translators, QA reviewers, native editors, and project managers',
        model_2_title: 'AI-assisted Translation',
        model_2_desc: 'Focus on the language you love without worrying about complex translation technology',
        model_2_item_1_title: 'AI Post-Editing',
        model_2_item_1_desc:
            'Modify translations in a WYSIWYG editor, empowered by AI for expert-level guidance and precise results',
        model_2_item_2_title: 'Translation Project Management',
        model_2_item_2_desc:
            'Multiple models, multiple languages, multiple workflows — collaboration works as a single mind, making project management simpler than ever',
        model_3_title: 'AI Toolkit',
        model_3_desc: 'AI translation tool series loved by professionals worldwide',
        model_3_comesoon: 'Coming Soon',
        model_3_item_1_title: 'AI Polisher',
        model_3_item_1_desc: 'Generative AI-based, your on-the-go native language touch-up expert',
        model_3_item_2_title: 'Corpus Aligner',
        model_3_item_2_desc:
            'Industry-leading alignment algorithm, brand new drag-and-drop alignment experience. AI makes corpus alignment easier',
        model_3_item_3_title: 'MT Detector',
        model_3_item_3_desc:
            'Intelligently recognizing machine translation, effectively identifying translation quality problems',
        model_3_item_4_title: 'Terminology Extractor',
        model_3_item_4_desc:
            'Intelligently extracting terms from bulk files and swiftly editing to create your termbases',
        model_3_item_5_title: 'QA Checker',
        model_3_item_5_desc: 'Not only provide rule-based QA, but also AI checking based on semantics',
        model_3_item_6_title: 'AI Dubber',
        model_3_item_6_desc: 'One click on translation and acoustic to instantly toggle the AI magic',
        model_3_item_7_title: 'AI Evaluation',
        model_3_item_7_desc: 'AI evaluation on MT, thus recommending the most suitable engine',
        model_4_title: 'Price',
        model_4_tab_1: 'Membership',
        model_4_tab_2: 'Characters',
        model_4_desc_1:
            'Document translation, text translation, and AI toolkit calculate characters according to the original text. Membership Service: Characters are valid within one month/half a year/one year from the purchase date, resetting monthly without carryover (',
        model_4_desc_link: 'Learn about character usage',
        model_4_desc_2: '). LanguageX reserves the right of final interpretation.',
        model_4_desc_3: 'View',
        model_4_desc_link_1: 'See full comparison',
        //feature_1
        model_4_item_1_title: 'FREE',
        model_4_item_1_feature_1: '12 general models',
        model_4_item_1_feature_2: '6 official personalized models',
        model_4_item_1_feature_3: '3 AI toolkits',
        model_4_item_1_feature_3_desc: 'AI Polisher, AI Evaluation, AI Dubber',
        // model_4_item_1_feature_4: "AI 润色",
        model_4_item_1_feature_5: '10,000 free characters per month',
        model_4_item_1_feature_6: 'File size: ≤ 5 MB',
        model_4_item_1_feature_7: 'One free trial of AI Dubber',
        model_4_item_1_feature_8: 'Text translation with LLMs',
        model_4_item_1_btn: 'Free Use',
        //feature_2
        model_4_item_2_title: 'PRO',
        model_4_item_2_feature_1: 'All Free features',
        model_4_item_2_feature_1_desc: 'Document translation with LLMs such as ChatGPT/Gemini/DeepSeek',
        model_4_item_2_feature_2: '9 vertical domain models',
        model_4_item_2_feature_3: 'Term customization',
        model_4_item_2_feature_4: 'Create your own personalized models',
        model_4_item_2_feature_5: '5 AI toolkits',
        model_4_item_2_feature_5_desc: 'AI Polisher, AI Evaluation, Terminology Extractor, AI Dubber, MT Detector',
        model_4_item_2_feature_6: '500,000 free characters per month',
        model_4_item_2_feature_7: 'File size: ≤ 30 MB',
        model_4_item_2_feature_8: 'PDF supported',
        model_4_item_2_price_1: '￥39',
        model_4_item_2_price_1_crossed: '￥59',
        model_4_item_2_price_1_expires: 'Month',
        model_4_item_2_price_2: '￥219',
        model_4_item_2_price_2_crossed: '￥329',
        model_4_item_2_price_2_expires: 'Half Year',
        model_4_item_2_price_3: '￥399',
        model_4_item_2_price_3_crossed: '￥599',
        model_4_item_2_price_3_expires: 'Year',
        model_4_item_2_btn: '7-day Free Trial',
        //feature_3
        model_4_item_3_title: 'Team/Enterprise Version',
        model_4_item_3_feature_1: 'All PRO features',
        model_4_item_3_feature_2: '2-10 million free characters per month',
        model_4_item_3_feature_3: 'All AI toolkits',
        model_4_item_3_feature_4: '20-500 files per project',
        model_4_item_3_feature_5: 'LLM Translation Agent',
        model_4_item_3_feature_6: 'File size: ≤ 100-500 MB',
        model_4_item_3_feature_7: '10-100 team members',
        model_4_item_3_feature_8: 'Scanned PDF & images',
        model_4_item_3_feature_9: 'Multilingual localization project management',
        model_4_item_3_feature_10: 'Exclusive technical support',
        model_4_item_3_btn: '7-day Free Trial',
        model_4_item_3_price_1: '￥12,000',
        model_4_item_3_price_1_crossed: '￥599',
        model_4_item_3_price_1_expires: 'Year',
        model_4_item_3_price_2: '￥23,800',
        model_4_item_3_price_2_crossed: '￥5,999',
        model_4_item_3_price_2_expires: 'Year',
        model_4_item_3_price_3: '￥35,600',
        model_4_item_3_price_3_crossed: '￥5,999',
        model_4_item_3_price_3_expires: 'Three years',
        //feature_4
        model_4_item_4_title: 'Education Version',
        model_4_item_4_feature_1: 'All PRO features',
        model_4_item_4_feature_2: '2,000,000 free characters per month',
        model_4_item_4_feature_3: 'All AI toolkits',
        model_4_item_4_feature_4: 'LLM Translation Agent',
        model_4_item_4_feature_5: 'Larger files',
        model_4_item_4_feature_6: 'More files per project',
        model_4_item_4_feature_7: 'Multilingual localization project management',
        model_4_item_4_feature_8: 'Customizable number of students',
        model_4_item_4_feature_9: 'Exclusive technical support',
        model_4_item_4_btn: 'Contact Us',
        model_4_char_btn_1: 'Buy Now',
        model_4_char_btn_2: 'Contact Us',
        model_4_char_1_title: '100,000 characters',
        model_4_char_1_price: '¥{price} RMB',
        model_4_char_1_desc: 'Equivalent to {price} RMB/ 10K characters',
        model_4_char_2_title: '500,000 characters ',
        model_4_char_2_price: '¥99',
        model_4_char_2_desc: 'equals to ¥1.99 per 10,000 characters',
        model_4_char_3_title: '1,000,000 characters',
        model_4_char_3_price: '¥179',
        model_4_char_3_desc: 'equals to ¥1.79 per 10,000 characters',
        model_4_char_4_title: '10,000,000 characters',
        model_4_char_4_price: '¥1,599',
        model_4_char_4_desc: 'equals to ¥1.59 per 10,000 characters',
        model_4_char_5_title: '>100 million characters',
        model_5_title: 'User Comments',
        model_5_experience_1: '{year} years of translation experience',
        model_5_experience_2: 'Lecturer at the University of Melbourne',
        model_5_experience_3: '{year} years of PM experience',
        model_5_experience_4: 'MTI student at Tianjin Foreign Studies University',
        model_5_item_1_user: 'Bobbie Chen',
        model_5_item_1_desc:
            'I like how simple the interface is. Having multiple translation models available for direct comparison means I don’t waste time switching between them. Overall, LanguageX is a rare, beginner-friendly translation assistant.',
        model_5_item_2_user: 'Lao Dingdang',
        model_5_item_2_desc:
            'Designed for professional translation — with Morandi-inspired colors, smooth animations, and foolproof workflows, LanguageX makes daily translation effortless and enjoyable. I’ve always believed that future translation tools should not only be powerful, but also warm, adaptable, and ever-refreshing. And now it’s here — LanguageX!',
        model_5_item_3_user: 'Flora Wang',
        model_5_item_3_desc:
            'I love LanguageX’s philosophy: “Let machines do what they do best, and let humans do what they do best.” It’s like a true partner — handling repetitive tasks while inspiring translators to produce high-quality work beyond what machines can do. Features like model comparison, Corpus Aligner, and AI Polisher are particularly impressive. If you’re still looking for an intuitive, ready-to-go translation tool, try LanguageX.',
        model_5_item_4_user: 'Hu Ke',
        model_5_item_4_desc:
            'For young translators and students just starting out in translation technology, LanguageX stands out in three ways. The interface of LanguageX is clear and user-friendly, making it easy to get started. Its comprehensive features — such as translation memories, termbases, and machine model comparison — help boost efficiency. Moreover, as a cloud-based platform, it works seamlessly across devices, fitting perfectly with the habits of younger translators.',
        model_5_item_5_user: 'Sherry Sui',
        model_5_item_5_desc:
            'The system interface is clear at a glance, with fresh colors and easy-to-use controls. It supports online project assignment, proofreading, QA, and more, while integrating major external models and search functions. With just one link, users can work anytime, anywhere.',
        model_5_item_6_user: 'Vicky Li',
        model_5_item_6_desc:
            'LanguageX provides a wide range of models and allows easy comparison between them, helping us manage projects across different types and domains more precisely. With a full set of tools available throughout the project lifecycle, it integrates translation and technology into a one-stop intelligent platform for translation projects.',
        model_5_item_7_user: 'Xu Jiamin',
        model_5_item_7_desc:
            'I’m impressed with how LanguageX works. Precise intelligent matching: Its AI-powered context recognition ensures precise matching with terminology databases (TB) and translation memories (TM), greatly reducing repetitive work. Real-time multi-user collaboration and cloud synchronization make project management efficient, ideal for team localization. The clean interface, fast response, and low hardware requirements allow smooth operation even during long sessions.',
        model_6_title: 'Join Us',
        model_6_left_item_1: 'We are enthusiasts of language and technology',
        model_6_left_item_2: 'We are translators between languages and technologies',
        model_6_left_item_3: 'We are hackers and painters',
        model_6_left_item_4:
            'Let’s build a new paradigm of collaboration between AI LLMs and language experts together',
        model_6_right_item_1: 'Translation is an art',
        model_6_right_item_2: 'Translators are cross-language writers',
        model_6_right_item_3: 'Let machines do what they do best, and let humans do what they do best',
        model_7_title: 'Our Customers',
        footer_product: 'Product',
        footer_product_1: 'AI Translation',
        footer_product_2: 'AI-assisted Translation',
        footer_product_3: 'AI Toolkit',
        footer_product_4: 'Translator Community',
        footer_product_5: 'LanguageX API',
        footer_help: 'Help Center',
        footer_help_1: 'What is LanguageX',
        footer_help_2: 'Guide to AI-assisted Translation',
        footer_help_3: 'Guide to AI Toolkit',
        footer_help_4: 'FAQ',
        footer_help_5: 'Guide to TMS Enterprise',
        footer_aboutus: 'About',
        footer_aboutus_1: 'Contact Us',
        footer_agreement: 'User Agreement',
        footer_agreement_1: 'Service Agreement',
        footer_agreement_2: 'Privacy Policy',
        footer_contact_1: 'Official Account',
        footer_contact_2: 'User Group',
    },
};
